export const dummyTeamSettingsData = {
  name: 'Team Settings',
  lines: [
    {
      label: 'Exclude Public & Premium Data',
      value: true,
      display_value: true,
      sortlevel: 1330,
      key: 'disallow_public_name_based_default_alternatives'
    },
    {
      label: 'Exclude Private Data',
      value: true,
      display_value: true,
      sortlevel: 1290,
      key: 'disallow_private_name_based_default_alternatives'
    },
    {
      label: 'Create closest-match alternatives',
      value: true,
      display_value: true,
      sortlevel: 110,
      key: 'create_closest_match_alternatives'
    },
    {
      label: 'Generic AI',
      value: true,
      display_value: true,
      sortlevel: 110,
      key: 'generic_ai_enabled'
    },
    {
      label: 'Auxiliaries AI',
      value: true,
      display_value: true,
      sortlevel: 110,
      key: 'auxiliaries_ai_enabled'
    },
    {
      label: 'IPC scraping enabled',
      value: true,
      display_value: true,
      sortlevel: 100,
      key: 'ipc_scraping_enabled'
    },
    {
      label: 'Alternatives AI',
      value: true,
      display_value: true,
      sortlevel: 110,
      key: 'alternatives_ai_enabled'
    },
    {
      label: 'Customer Taxonomy',
      value: 'Customer Taxonomy',
      display_value: 'Customer Taxonomy',
      sortlevel: 138,
      key: 'customer_taxonomy_name'
    },
    {
      label: 'Preferred Currency',
      value: 'USD',
      display_value: 'USD',
      sortlevel: 120,
      key: 'preferred_currency'
    },
    {
      label: 'Company Name',
      value: 'spinnmaster',
      display_value: 'spinnmaster',
      sortlevel: 140,
      key: 'company_name'
    },
    {
      label: 'Use supplier geo for IMDS',
      value: true,
      display_value: true,
      sortlevel: 115,
      key: 'imds_use_supplier_geo'
    }
  ],
  formSchema: [
    {
      description: 'Prevent public and premium datasets from being assigned as default alternatives.',
      mandatory: false,
      defaultValue: 'false',
      formtype: 'checkbox',
      section: 'Team Settings',
      title: 'Exclude Public & Premium Data',
      sortlevel: 1330,
      fieldtype: 'BOOLEAN',
      enum: null,
      key: 'disallow_public_name_based_default_alternatives'
    },
    {
      description: 'If checked, will use AI to predict the exiobase sector when importing transactions',
      mandatory: false,
      defaultValue: 'FALSE',
      formtype: 'checkbox',
      section: 'Team Settings',
      title: 'AI Exiobase sector prediction',
      sortlevel: 117,
      fieldtype: 'BOOLEAN',
      enum: null,
      key: 'ai_predict_exiobase_sector'
    },
    {
      description: 'Enable compliance calculations from IPC live feed imports',
      mandatory: false,
      defaultValue: 'false',
      formtype: 'checkbox',
      section: 'Team Settings',
      title: 'Enable IPC Live Feed Compliance',
      sortlevel: 112,
      fieldtype: 'BOOLEAN',
      enum: null,
      key: 'enable_ipc_live_feed_compliance'
    },
    {
      description: 'Prevent private datasets from being assigned as default alternatives.',
      mandatory: false,
      defaultValue: 'true',
      formtype: 'checkbox',
      section: 'Team Settings',
      title: 'Exclude Private Data',
      sortlevel: 1290,
      fieldtype: 'BOOLEAN',
      enum: null,
      key: 'disallow_private_name_based_default_alternatives'
    },
    {
      description: 'Remove default alternatives when a Supply Chain is matched',
      mandatory: false,
      defaultValue: 'false',
      formtype: 'checkbox',
      section: 'Team Settings',
      sortlevel: 112,
      title: 'Remove default alternatives when a Supply Chain is matched',
      fieldtype: 'BOOLEAN',
      enum: null,
      key: 'unset_default_alternatives_for_nonleaf_pg'
    },
    {
      description: 'When this is on, will attempt creating generic AI predictions for auxiliaries',
      mandatory: false,
      defaultValue: 'FALSE',
      formtype: 'checkbox',
      section: 'Team Settings',
      title: 'Create generic AI predictions for auxiliaries',
      sortlevel: 137,
      fieldtype: 'BOOLEAN',
      enum: null,
      key: 'generic_ai_predict_auxiliaries'
    },
    {
      description: 'Preferred Currency for team.',
      mandatory: false,
      defaultValue: null,
      formtype: 'select',
      section: 'Team Settings',
      title: 'Preferred Currency',
      sortlevel: 120,
      enum: [
        {
          name: 'EUR',
          value: 'EUR'
        },
        {
          name: 'GBP',
          value: 'GBP'
        },
        {
          name: 'USD',
          value: 'USD'
        }
      ],
      fieldtype: 'STRING',
      key: 'currency_preferred'
    },
    {
      description: 'Enable/disable using AI to provide closest-match alternatives when no exact match is found',
      mandatory: false,
      defaultValue: 'FALSE',
      formtype: 'checkbox',
      section: 'Team Settings',
      title: 'Create closest-match alternatives',
      sortlevel: 110,
      fieldtype: 'BOOLEAN',
      enum: null,
      key: 'create_closest_match_alternatives'
    },
    {
      description: 'Remove public and premium products from replacement suggestions',
      mandatory: false,
      defaultValue: 'FALSE',
      formtype: 'checkbox',
      section: 'Team Settings',
      title: 'Ecodesign: private products only',
      sortlevel: 105,
      fieldtype: 'BOOLEAN',
      enum: null,
      key: 'ecodesign_skip_premium'
    },
    {
      description: 'Make compliance questionnaire attachments optional for suppliers',
      mandatory: false,
      defaultValue: 'false',
      formtype: 'checkbox',
      section: 'Team Settings',
      title: 'Make compliance questionnaire attachments optional',
      sortlevel: 230,
      fieldtype: 'BOOLEAN',
      enum: null,
      key: 'questionnaire_attachment_optional'
    },
    {
      description:
        'Predict material compositions and manufacturing processes for BOM, Transaction, and Process imports',
      mandatory: false,
      defaultValue: 'FALSE',
      formtype: 'checkbox',
      section: 'Team Settings',
      title: 'Generic AI',
      sortlevel: 110,
      fieldtype: 'BOOLEAN',
      enum: null,
      key: 'generic_ai_enabled'
    },
    {
      description: 'Scope 3 dashboard user context',
      mandatory: false,
      defaultValue: null,
      multiplicity: 'single',
      formtype: 'autocomplete',
      options: 'userandteam/search',
      section: 'Team Settings',
      title: 'Scope 3 dashboard user context',
      sortlevel: 144,
      fieldtype: 'LINK',
      enum: null,
      key: 'default_scope3_user_rid'
    },
    {
      description: 'Email to send makersite email messages',
      mandatory: false,
      defaultValue: null,
      formtype: 'text',
      section: 'Team Settings',
      title: 'Project Manager Email',
      sortlevel: 130,
      fieldtype: 'STRING',
      enum: null,
      key: 'project_manager_email'
    },
    {
      description: 'Predict auxiliary processes for components in IPC imports',
      mandatory: false,
      defaultValue: 'FALSE',
      formtype: 'checkbox',
      section: 'Team Settings',
      title: 'Auxiliaries AI',
      sortlevel: 110,
      fieldtype: 'BOOLEAN',
      enum: null,
      key: 'auxiliaries_ai_enabled'
    },
    {
      description: 'Enable/disable IPC scraping functionality',
      mandatory: false,
      defaultValue: 'FALSE',
      formtype: 'checkbox',
      section: 'Team Settings',
      title: 'IPC scraping enabled',
      sortlevel: 100,
      fieldtype: 'BOOLEAN',
      enum: null,
      key: 'ipc_scraping_enabled'
    },
    {
      description: 'Will not create any default alternatives if this is enabled',
      mandatory: false,
      defaultValue: 'false',
      formtype: 'checkbox',
      section: 'Team Settings',
      title: 'Skip assigning default alternatives',
      sortlevel: 100,
      fieldtype: 'BOOLEAN',
      enum: null,
      key: 'skip_assigning_default_alternatives'
    },
    {
      description: 'Enable BOM import octopart enrichment',
      mandatory: false,
      defaultValue: 'true',
      formtype: 'checkbox',
      section: 'Team Settings',
      title: 'Enable Octopart enrichment',
      sortlevel: 110,
      fieldtype: 'BOOLEAN',
      enum: null,
      key: 'enable_bom_import_octopart_enrichment'
    },
    {
      description: 'Recommend and map alternatives or equivalent components in IPC imports',
      mandatory: false,
      defaultValue: 'FALSE',
      formtype: 'checkbox',
      section: 'Team Settings',
      title: 'Alternatives AI',
      sortlevel: 110,
      fieldtype: 'BOOLEAN',
      enum: null,
      key: 'alternatives_ai_enabled'
    },
    {
      description: 'Include WIAM products in compliance',
      mandatory: false,
      defaultValue: 'false',
      formtype: 'checkbox',
      section: 'Team Settings',
      title: 'Include WIAM Products In Compliance',
      sortlevel: 220,
      fieldtype: 'BOOLEAN',
      enum: null,
      key: 'include_wiam_in_compliance'
    },
    {
      description: 'Supplier user data set visibility on Material Breakdown Questionnaire response.',
      mandatory: false,
      defaultValue: 'all_datasets',
      formtype: 'select',
      section: 'Team Settings',
      title: 'Supplier data on Material Breakdown',
      sortlevel: 145,
      enum: [
        {
          name: 'All data sets',
          value: 'all_datasets'
        },
        {
          name: 'Only shared data sets',
          value: 'shared_datasets'
        }
      ],
      fieldtype: 'STRING',
      key: 'material_breakdown_dataset_search_scope'
    },
    {
      description: 'Will not create any preferred routes during BOM imports if this is enabled',
      mandatory: false,
      defaultValue: 'false',
      formtype: 'checkbox',
      section: 'Team Settings',
      title: 'Do not create Preferred Routes in BOMs',
      sortlevel: 101,
      fieldtype: 'BOOLEAN',
      enum: null,
      key: 'skip_assigning_preferred_routes_in_boms'
    },
    {
      description: 'Configures which section of PCF Questionnaire Supplier will see in a received Questionnaire.',
      mandatory: false,
      defaultValue: null,
      formtype: 'select',
      section: 'Team Settings',
      title: 'Section of PCF Questionnaire to show',
      sortlevel: 140,
      enum: [
        {
          name: 'PCF Reporting',
          value: 'pcf_reporting'
        },
        {
          name: 'Material Breakdown only',
          value: 'material_breakdown'
        }
      ],
      fieldtype: 'EMBEDDEDLIST',
      key: 'pcf_questionnaire_sections_to_display'
    },
    {
      description: 'Enable nightly downstream compliance calculations',
      mandatory: false,
      defaultValue: 'false',
      formtype: 'checkbox',
      section: 'Team Settings',
      title: 'Enable Downstream Compliance',
      sortlevel: 111,
      fieldtype: 'BOOLEAN',
      enum: null,
      key: 'enable_downstream_compliance'
    },
    {
      description: 'Your custom taxonomy name',
      mandatory: false,
      defaultValue: 'Customer Taxonomy',
      formtype: 'text',
      section: 'Team Settings',
      title: 'Customer Taxonomy',
      sortlevel: 138,
      fieldtype: 'STRING',
      enum: null,
      key: 'customer_taxonomy_name'
    },
    {
      description: 'Predict chemical synthesis route with AI',
      mandatory: false,
      defaultValue: 'FALSE',
      formtype: 'checkbox',
      section: 'Team Settings',
      title: 'Chemical AI',
      sortlevel: 110,
      fieldtype: 'BOOLEAN',
      enum: null,
      key: 'use_chemical_ai_for_prediction'
    },
    {
      description: 'Preferred Currency for team.',
      mandatory: false,
      defaultValue: 'USD',
      formtype: 'select',
      section: 'Team Settings',
      title: 'Preferred Currency',
      sortlevel: 120,
      enum: [
        {
          name: 'EUR',
          value: 'EUR'
        },
        {
          name: 'GBP',
          value: 'GBP'
        }
      ],
      fieldtype: 'STRING',
      key: 'preferred_currency'
    },
    {
      description: 'Default Company for Hotspots dashboard',
      mandatory: false,
      defaultValue: null,
      multiplicity: 'single',
      formtype: 'autocomplete',
      options: 'company/search',
      section: 'Team Settings',
      title: 'Default Company for Hotspots dashboard',
      sortlevel: 143,
      fieldtype: 'LINK',
      enum: null,
      key: 'default_company_rid'
    },
    {
      description: 'imported bom will automatically shared with team if imported by this service user',
      mandatory: false,
      defaultValue: null,
      formtype: 'userpicker',
      section: 'Team Settings',
      title: 'Service user to share imported bom with team',
      sortlevel: 102,
      fieldtype: 'LINK',
      enum: null,
      key: 'service_user_to_share_bom_import_with_team'
    },
    {
      description: 'The name of the company',
      mandatory: true,
      defaultValue: '',
      formtype: 'text',
      section: 'Team Settings',
      title: 'Company Name',
      sortlevel: 140,
      fieldtype: 'STRING',
      enum: null,
      key: 'company_name'
    },
    {
      description:
        'When this is on, the system might automatically assign alternatives matched by name, as default alternatives',
      mandatory: false,
      defaultValue: 'false',
      formtype: 'checkbox',
      section: 'Team Settings',
      title: 'Allow default name-based alternatives',
      sortlevel: 194,
      fieldtype: 'BOOLEAN',
      enum: null,
      key: 'allow_default_name_alternatives'
    },
    {
      description: 'Use supplier information from IMDS to set geographic location on imported processes',
      mandatory: false,
      defaultValue: 'false',
      formtype: 'checkbox',
      section: 'Team Settings',
      title: 'Use supplier geo for IMDS',
      sortlevel: 115,
      fieldtype: 'BOOLEAN',
      enum: null,
      key: 'imds_use_supplier_geo'
    }
  ],
  sortlevel: 100
};

export enum PredictionModel {
  v1 = 'v1.0',
  v2 = 'v2.0'
}
